'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildThreadHistoryFromResponse = undefined;

var _ThreadHistory = require('conversations-schema/thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildThreadHistoryFromResponse = exports.buildThreadHistoryFromResponse = function buildThreadHistoryFromResponse(threadHistory) {
  return new _ThreadHistory2.default(threadHistory);
};


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/operators/buildThreadHistoryFromResponse.js
// module id = 522
// module chunks = 2 3